if(!customElements.get('product-quiz')){
  customElements.define('product-quiz', class ProductQuiz extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        mainHeader: 'vbb-main-header',
        picker: 'vbb-product-quiz__picker',
        wrapper: 'vbb-product-quiz__picker__wrapper',
        pickerActive: 'vbb-product-quiz__picker--active',
        wrapperActive: 'vbb-product-quiz__picker__wrapper--active',
        winner: 'vbb-product-quiz__winner-section',
        winnerActive: 'vbb-product-quiz__winner-section--active',
      };

      this.startQuizSubscriber = subscribe(PUB_SUB_EVENTS['start-quiz'], () => this.startQuiz());
      this.pickerElements = this.querySelectorAll(`.${this.classes.picker}`);

      this.getUniqueUserID();

      this.form =  document.querySelector('#shade-quiz-recommended-block')
      this.setupForm()
    }
    setupForm(){

      this.emailFormEnabled = document.querySelector('#shade-recommended-email') ? true : false;
      if(this.emailFormEnabled){
        document.querySelector('#shade-recommended-email__skip').addEventListener('click', (event) => {
          event.preventDefault();
          this.handleQuizCompleted();
        });

        const form = document.querySelector('#shade-recommended-email');
        const button = document.querySelector('#shade-recommended-submit');
        const jsonData = JSON.parse(document.querySelector('.vbb-product-quiz__email script[type="application/json"]').textContent);

        if (button && form.dataset.formId && jsonData) {
          button.addEventListener('click', (e) => {
            // REMOVE THIS LINE
            e.preventDefault(); // Prevent form submission
            const email = form.querySelector('input[type="email"]').value;
            if(email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
              const attentiveKeysEl = document.querySelector('script[data-attentive-keys]');
              if (attentiveKeysEl) {
                const attentiveKeys = JSON.parse(attentiveKeysEl.textContent);
                const matchingAttentiveKey = attentiveKeys[this.quizWinner];

                fetch("https://a.klaviyo.com/client/events/?company_id=TkRNkf", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "revision": "2025-01-15",
                  },
                  body: JSON.stringify({
                    data: {
                      type: "event",
                      attributes: {
                        profile: {
                          data: {
                            type: "profile",
                            attributes: {
                              email,
                            },
                          },
                        },
                        metric: {
                          data: {
                            type: "metric",
                            attributes: {
                              name: "Submitted Product Quiz",
                            },
                          },
                        },
                        properties: {
                          frag_quiz_description: matchingAttentiveKey.title,
                          frag_quiz_result: matchingAttentiveKey.description,
                          formId: form.dataset.formId,
                        },
                      },
                    },
                  }),
                }).then(response => {
                  if (response.ok) {
                    return response.json();
                  }
                  throw new Error('Network response was not ok.');
                }).then(data => {
                  console.log(data);
                }).catch(error => {
                  console.error('There has been a problem with your fetch operation:', error);
                });
                this.handleQuizCompleted()
              }
            }
          })
        }
      }
    }

    getUniqueUserID() {
      // Check if we already have one in localStorage
      this.uniqueUserId = localStorage.getItem('vbb-unique-user-id');

      if (this.uniqueUserId == null) {
        const uuid = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );

        this.uniqueUserId = uuid;
        localStorage.setItem('vbb-unique-user-id', uuid);
      }
    }
    setupPickers() {
      this.pickers = [];

      if (this.pickerElements.length > 0) {
        this.pickerElements.forEach(pickerElement => {
          // Add picker to list along with associated data
          this.pickers.push({
            el: pickerElement,
            isTieBreaker: pickerElement.dataset.isTieBreaker === 'true',
            minAnswers: parseInt(pickerElement.dataset.minSelectedAnswers, 10),
            maxAnswers: parseInt(pickerElement.dataset.maxSelectedAnswers, 10),
            answers: pickerElement.querySelectorAll('li'),
            activeAnswers: [],
            lastSelectedAnswer: null,
          });

          // Add event listeners to each answer
          pickerElement.querySelectorAll('button').forEach(button => {
            button.addEventListener('click', () => {
              const picker = this.pickers.find(picker => picker.el === pickerElement);
              const answer = button.closest('li');

              if (picker) {
                this.updatePickerAnswers(picker, answer);
                this.setActivePickerAnswers(picker);
                if (this.quizCompleted) {
                  this.handleQuizCompleted(this.form);
                } else {
                  this.handleQuizNotCompleted();
                }

                this.updateActivePickers();
              }
            });
          });
        });
      }
    }

    startQuiz() {
      this.clearAnswersOnPickers(this.pickers);
      this.pickers[0].el.parentElement.classList.add(this.classes.wrapperActive);
      this.scrollToPosition(this.getScrollTopForPicker(this.pickers[0]));
    }

    getScrollTopForPicker(picker) {
      const headerRect = document.querySelector(`.${this.classes.mainHeader}`).getBoundingClientRect();
      const pickerRect = picker.el.parentElement.getBoundingClientRect();
      return ((pickerRect.top + window.scrollY) - headerRect.height);
    }

    scrollToPosition(top) {
      window.scrollTo({
        top,
        left: 0,
        behavior: 'smooth',
      });
    }

    handleQuizCompleted(quiz) {
      if(quiz){
          quiz.style.display = 'block';
          this.scrollToPosition(quiz.offsetTop - document.querySelector(`.${this.classes.mainHeader}`).offsetHeight);
      } else {
        document.querySelectorAll(`.${this.classes.winner}`).forEach(section => {
          section.classList.remove(this.classes.winnerActive);

          if (
            (section.dataset.targetQuizOption !== '' && section.dataset.targetQuizOption === this.quizWinner)
            || (section.dataset.displayWhenQuizCompleted === 'true')
          ) {
            section.classList.add(this.classes.winnerActive);
          }
        });

        const multiColumn = document.querySelector('.vbb-multi-column.vbb-product-quiz__winner-section--active');

        if (multiColumn) {
          const nonWinners = this.dataset.options
            .split(',')
            .map(option => option.split(':')[0])
            .filter(option => option !== this.quizWinner);

          const orderedOptions = [...nonWinners, this.quizWinner];

          orderedOptions.forEach((option, index) => {
            const column = multiColumn.querySelector(`.vbb-multi-column__column[data-target-option="${option}"]`);

            if (column) {
              column.style.order = index;
            }
          });
        }
        this.scrollToPosition(document.querySelector('.vbb-product-quiz__winner-section--active').offsetTop - document.querySelector(`.${this.classes.mainHeader}`).offsetHeight);
        this.sendTrackingData();
      }
    }

    sendTrackingData() {
      const trackingData = {
        event: 'product_quiz_completed',
        quiz_user_id: this.uniqueUserId,
        quiz_answers: this.pickers.map(picker => picker.activeAnswers.map(answer => answer.dataset.gtmValue.replace('\n', ''))),
        quiz_results: Object.entries(this.tally).map(([option, count]) => ({ option, count })),
        quiz_winner: this.quizWinner,
      };

      window.Shopify.analytics.publish('custom_product_quiz_completed', trackingData);
    }

    handleQuizNotCompleted() {
      document.querySelectorAll(`.${this.classes.winner}`).forEach(section => {
        section.classList.remove(this.classes.winnerActive);
      });
    }

    updatePickerAnswers(picker, answer) {
      picker.lastSelectedAnswer = answer;

      if (picker.activeAnswers.includes(answer)) {
        picker.activeAnswers = picker.activeAnswers.filter(activeAnswer => activeAnswer !== answer);

      } else {
        if (picker.activeAnswers.length === picker.maxAnswers) {
          picker.activeAnswers.pop();
        }

        picker.activeAnswers.push(answer);
      }
    }

    setActivePickerAnswers(picker) {
      picker.answers.forEach(answer => {
        if (picker.activeAnswers.includes(answer)) {
          answer.classList.add('active');
        } else {
          answer.classList.remove('active');
        }
      });
    }

    clearAnswersOnPickers(pickers) {
      pickers.forEach(picker => {
        picker.activeAnswers = [];
        picker.lastSelectedAnswer = null;
        picker.el.parentElement.classList.remove(this.classes.wrapperActive);
        this.setActivePickerAnswers(picker);
      });
    }

    updateActivePickers() {
      for (const picker of this.pickers) {
        const pickerIndex = this.pickers.indexOf(picker);
        const nextPickerIndex = pickerIndex + 1;

        if (picker.activeAnswers.length < picker.minAnswers) {
          this.clearAnswersOnPickers(this.pickers.filter((innerPicker, index) => {
            return (index > pickerIndex) && (innerPicker !== picker);
          }));

          break;
        } else if (this.pickers[nextPickerIndex]) {
          this.pickers[nextPickerIndex].el.parentElement.classList.add(this.classes.wrapperActive);
        }
      }

      const activePickers = Array.from(this.pickers).filter(({ el }) => el.parentElement.classList.contains(this.classes.wrapperActive));
      const lastActivePicker = activePickers[activePickers.length - 1];

      if (lastActivePicker.activeAnswers.length === lastActivePicker.minAnswers) {
        const firstWinnerSection = document.querySelector(`.${this.classes.winnerActive}`);

        if (firstWinnerSection) {
          this.scrollToPosition(firstWinnerSection.offsetTop - document.querySelector(`.${this.classes.mainHeader}`).offsetHeight);
        }
      } else {
        this.scrollToPosition(this.getScrollTopForPicker(lastActivePicker));
      }
    }

    isResultTied(partialTally) {
      const mergedTally = { ...this.baseTally };
      Object.keys(partialTally).forEach(key => {
        mergedTally[key] = (mergedTally[key] || 0) + partialTally[key];
      });

      const values = Object.values(mergedTally).filter(value => value > 0);

      return (
        (values.length > 0)
        && (new Set(values).size < values.length)
      );
    }

    get baseTally() {
      return this.dataset.options.split(',').reduce((acc, option) => {
        const [name, startValue] = option.split(':');
        acc[name] = parseInt(startValue, 10);
        return acc;
      }, {});
    }

    get pickerTally() {
      return this.pickers.reduce((acc, picker, index) => {
        const activeAnswers = picker.activeAnswers;

        if (activeAnswers.length > 0) {
          activeAnswers.forEach(activeAnswer => {
            const targetOption = activeAnswer.dataset.targetOption;
            let amountToAdd = parseInt(activeAnswer.dataset.value, 10);
            let currentPickerIsTieBreaker = this.pickers[index].isTieBreaker;

            if (currentPickerIsTieBreaker) {
              // checks if tie breaker amount is needed

              const shallowAmounttoAdd = amountToAdd * 2;
              const shallowCopyOfAcc = { ...acc };

              shallowCopyOfAcc[targetOption] = (shallowCopyOfAcc[targetOption] || 0) + shallowAmounttoAdd

              // Check if the highest number is a duplicate
              const values = Object.values(shallowCopyOfAcc);
              const maxNumber = Math.max(...values);
              const maxNumberCount = values.filter(value => value === maxNumber).length;
              // Only multiply amountToAdd if the final result is not a duplicate
              if (maxNumberCount === 1) {
                amountToAdd *= 2;
              }

            }
            acc[targetOption] = (acc[targetOption] || 0) + amountToAdd;
          });
        }
        return acc;
      }, {});
    }

    get tally() {
      const base = this.baseTally;
      const picker = this.pickerTally;

      Object.keys(base).forEach(key => {
        base[key] += (picker[key] || 0);
      });

      return base;
    }

    get quizCompleted() {
      return this.pickers.every(picker => picker.activeAnswers.length >= picker.minAnswers);
    }

    get quizWinner() {
      if (this.quizCompleted) {
        const tally = this.tally;
        const max = Math.max(...Object.values(tally));
        return Object.keys(tally).find(key => tally[key] === max);

      }

      return null;
    }

    connectedCallback() {
      this.setupPickers();
    }
  });
}
